import React from 'react';
import { ErrorMessage } from 'formik';
import Required from '../../../../../components/Required/required.component';
import Input from '../../../../../components/Input/input.component';
import { numberMask } from '../../../../../components/Input/Masks';

const EditarHistoricoDefesaCivil = (props) => {
	const { handleChange, transacao } = props;

	return (
		<React.Fragment>
			<div className='row'>
				<div className='col-md-6'>
					<label>
						Quantidade: <Required />
					</label>
					<div className='form-group'>
						<Input
							type='text'
							mask={numberMask}
							name='quantidadeEntradaSaida'
							onChange={handleChange}
							value={transacao.quantidadeEntradaSaida}
							maxLength={18}
						/>
						<ErrorMessage
							name='quantidadeEntradaSaida'
							render={msg => (
								<span className='text-danger'>
									{msg}
								</span>
							)}
						/>
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default EditarHistoricoDefesaCivil;
